import { keys, flatMap, sortBy, map, range, reduce } from 'lodash';

const tileConfig: { [letter: string]: number } = {
    J: 2,
    K: 2,
    Q: 2,
    X: 2,
    Z: 2,
    B: 3,
    C: 3,
    F: 3,
    H: 3,
    M: 3,
    P: 3,
    V: 3,
    W: 3,
    Y: 3,
    G: 4,
    L: 5,
    D: 6,
    S: 6,
    U: 6,
    N: 8,
    T: 9,
    R: 9,
    O: 11,
    I: 12,
    A: 13,
    E: 18,
};

// We can either precompute the draw order
// or we can use cloud functions
// to determine the which tile is drawn
// How can we make this deterministic?
export const allTiles = (() => {
    let id = 1;
    return flatMap(sortBy(keys(tileConfig)), (letter) => {
        return map(range(0, tileConfig[letter]), () => ({
            letter,
            id: id++,
        }));
    });
})();

export const idToTileMap = reduce(
    allTiles,
    (acc, { letter, id }) => {
        acc[id] = letter;
        return acc;
    },
    {} as {[id: number]: string},
);


